const React = require('react');
const { useTranslation } = require('react-i18next');
const GlobalSearchResultRow = require('./GlobalSearchResultRow');

const GlobalSearchEmptyState = ({ message }) => (
  <div className='globalSearchResults__empty'>{message}</div>
);

const GlobalSearchResults = ({
  results,
  totalMatches,
  hasQuery,
  activeIndex,
  onSelect,
  onHover,
  rowRefs,
}) => {
  const { t } = useTranslation();

  if (!hasQuery) {
    return <GlobalSearchEmptyState message={t('global_search_empty_hint')} />;
  }
  if (results.length === 0) {
    return <GlobalSearchEmptyState message={t('global_search_no_results')} />;
  }

  return (
    <React.Fragment>
      {results.map((entry, index) => (
        <GlobalSearchResultRow
          key={entry.key}
          entry={entry}
          index={index}
          isActive={index === activeIndex}
          onSelect={onSelect}
          onHover={onHover}
          rowRef={(node) => {
            rowRefs.current[index] = node;
          }}
        />
      ))}
      {totalMatches > results.length ? (
        <div className='globalSearchResults__truncated'>
          {/* `shown`, not `count` — i18next treats `count` as a plural key. */}
          {t('global_search_more_results', {
            shown: results.length,
            total: totalMatches,
          })}
        </div>
      ) : null}
    </React.Fragment>
  );
};

module.exports = GlobalSearchResults;
